export function isHubCenter(hubItem) {
  if (!hubItem) {
    return false;
  }

  const centerFlag = hubItem.is_center;
  return centerFlag === true || centerFlag === 1 || centerFlag === "1";
}

export function getHubOptionLabel(hubItem) {
  const hubName = String(hubItem?.name ?? "").trim();
  if (!hubName) {
    return "";
  }

  return isHubCenter(hubItem) ? `${hubName} (Center)` : hubName;
}

export function mapMyHubsToSelectOptions(myHubsData) {
  if (!myHubsData?.hub) {
    return [];
  }

  const flatHubs = [myHubsData.hub, ...(myHubsData.childs_hub || [])].filter(Boolean);

  return flatHubs.map(hubItem => ({
    value: String(hubItem.id),
    label: getHubOptionLabel(hubItem),
  }));
}

export function joinMultiSelectIds({ selectedIds, options }) {
  const allIds = (options || [])
    .map(optionItem => String(optionItem?.value || "").trim())
    .filter(optionValue => /^\d+$/.test(optionValue))
    .join(",");

  if (!Array.isArray(selectedIds) || !selectedIds.length) {
    return allIds;
  }

  const selectedJoined = selectedIds
    .map(optionId => String(optionId).trim())
    .filter(optionId => /^\d+$/.test(optionId))
    .join(",");

  return selectedJoined || allIds;
}

export function parseMultiSelectIds(raw) {
  if (Array.isArray(raw)) {
    return raw.map(optionId => String(optionId).trim()).filter(Boolean);
  }

  if (raw == null || raw === "") {
    return [];
  }

  return String(raw)
    .split(",")
    .map(optionId => optionId.trim())
    .filter(Boolean);
}
